import React, { useEffect, useState } from "react";
import logo from "../assets/images/Logo/web_logo.png";
import PrimaryBtn from "../components/button/PrimaryBtn";
import { PasswordInput } from "../components/form/inputs";
import { Link, useNavigate } from "react-router-dom";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { setPassword } from "../redux/thunks/registerThunks";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

const ResetPass = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [password, setPasswordState] = useState("");
  const [passErr, setPassErr] = useState("");
  const [repassword, setRepassword] = useState("");
  const [repassErr, setRepassErr] = useState("");
  const passwordRules = {
    uppercase: /[A-Z]/,
    lowercase: /[a-z]/,
    number: /[0-9]/,
    special: /[!@#$%^&*]/,
    length: /.{8,}/,
  };

  const { forgotUserId, forgototptype, forgotEmail, isLoading } = useSelector(
    (state) => state.login
  );

  const checkRule = (rule) => rule.test(password);
  const RuleItem = ({ valid, text }) => (
    <div className="flex items-center gap-2 text-sm text-[#4A4A4A]">
      <span
        className={`text-lg font-bold ${
          valid ? "text-[#FF6943]" : "text-gray-300"
        }`}
      >
        ✓
      </span>
      <span>{text}</span>
    </div>
  );

  useEffect(() => {
    if (!forgotUserId || !forgototptype) {
      toast.error("Please complete previous steps first");
      navigate("/forgot-password"); // or /otp-varify depending on flow
    }
  }, [forgotUserId, forgototptype]);

  const validatePassword = () => {
    if (!password) {
      setPassErr("Password is required");
      return false;
    } else if (
      !checkRule(passwordRules.uppercase) ||
      !checkRule(passwordRules.lowercase) ||
      !checkRule(passwordRules.number) ||
      !checkRule(passwordRules.special) ||
      !checkRule(passwordRules.length)
    ) {
      setPassErr("Password does not meet all requirements");
      return false;
    }
    setPassErr("");
    return true;
  };

  const validateRePassword = () => {
    if (!repassword) {
      setRepassErr("Please re-enter password");
      return false;
    } else if (password !== repassword) {
      setRepassErr("Passwords do not match");
      return false;
    }
    setRepassErr("");
    return true;
  };

  const handleNav = () => {
    const payload = {
      user_id: forgotUserId,
      password: password,
      password_confirmation: repassword,
      otp_type: forgototptype,
    };
    // console.log("The payload is :", payload);
    if (validatePassword() && validateRePassword()) {
      dispatch(setPassword(payload)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          // show toast here
          toast.success(res.payload.message || "Password set successfully");
          navigate("/login");
        } else {
          toast.error(res.payload || "Something went wrong");
        }
      });
    }
  };

  return (
    <section className="flex   flex-col items-center justify-center min-h-screen w-full px-4 sm:px-6 md:px-10 bg-gray-50 lg:bg-gradient-to-br lg:from-orange-50 lg:to-orange-100">
      <DecorativeSquares />
      <div className="w-full space-y-4 sm:w-11/12 md:w-3/4 lg:w-[450px] xl:w-[400px] bg-white flex flex-col items-center text-center py-8 px-4 rounded-2xl shadow-none md:shadow-lg">
        {/* Logo & Tagline */}
        <div className="flex flex-col items-center gap-2 space-y-4">
          <img src={logo} alt="web_logo" className="w-20 h-20 object-contain" />
          <p className="text-gray-400 text-sm text-center">
            You Cook, We Manage the Rest
          </p>
          <p className="text-black text-lg text-center">Set Your Password</p>
        </div>

        {/* OTP Form */}
        <div className="w-full flex flex-col gap-5 text-start mt-8">
          <div className="flex flex-col gap-2">
            {/* OTP Boxes */}
            <PasswordInput
              label="Password"
              value={password}
              onChange={(e) => setPasswordState(e.target.value)}
              placeholder="Enter Your Password"
              required
              showPasswordToggle
              error={passErr}
            />

            <PasswordInput
              label="Re enter password"
              value={repassword}
              onChange={(e) => setRepassword(e.target.value)}
              placeholder="Re enter password"
              required
              showPasswordToggle
              error={repassErr}
            />
            <div className="space-y-3 mt-2">
              <RuleItem
                valid={checkRule(passwordRules.uppercase)}
                text="At least one uppercase letter (A-Z)"
              />
              <RuleItem
                valid={checkRule(passwordRules.lowercase)}
                text="At least one lowercase letter (a-z)"
              />
              <RuleItem
                valid={checkRule(passwordRules.number)}
                text="At least one number (0-9)"
              />
              <RuleItem
                valid={checkRule(passwordRules.special)}
                text="At least one special character (!@#$%^&*)"
              />
              <RuleItem
                valid={checkRule(passwordRules.length)}
                text="Minimum 8 characters"
              />
            </div>
          </div>
        </div>

        <PrimaryBtn
          btnName="Next"
          extraClass="mt-8"
          clickEvent={handleNav}
          isLoading={isLoading}
        />
      </div>
    </section>
  );
};

export default ResetPass;
